import React, { useEffect } from "react";

const DynamicImgResizeComponent = (props) => {
  const [resizedImage, setResizedImage] = React.useState("");

  useEffect(() => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = props.imageProps.targetWidth;
    canvas.height = props.imageProps.targetHeight;
    const originalImg = props.imageProps.originalImg;
    const imgType = props.imageProps.imgType;
    if (ctx) {
      // Draw the image onto the canvas with the specified dimensions
      img.onload = () => {
        ctx.drawImage(
          img,
          0,
          0,
          props.imageProps.targetWidth,
          props.imageProps.targetHeight
        );

        // Convert the canvas content to a data URL representing the resized image
        const resizedImageDataUrl = canvas.toDataURL(imgType);
        setResizedImage(resizedImageDataUrl);
      };
      img.src = originalImg;
    }
  }, [
    props.imageProps.originalImg,
    props.imageProps.targetWidth,
    props.imageProps.targetHeight,
    props.imageProps.imgType,
  ]);

  return <img src={resizedImage} />;
};

export default DynamicImgResizeComponent;
